"use client";
import { Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/hooks/useLanguage";

export function LanguageToggle() {
	const { language, toggleLanguage } = useLanguage();

	return (
		<Button
			variant="outline"
			size="icon"
			onClick={toggleLanguage}
			className="relative text-light-text dark:text-dark-text border-light-border dark:border-dark-border hover:bg-light-surface dark:hover:bg-dark-surface"
		>
			<Globe className="h-[1.2rem] w-[1.2rem] transition-all" />
			<span className="absolute -top-1 -right-1 bg-light-accent dark:bg-dark-accent text-white text-xs px-1 py-0.5 rounded-full text-[10px] font-bold">
				{language === "zh" ? "中" : "EN"}
			</span>
			<span className="sr-only">
				{language === "zh" ? "切换语言" : "Toggle language"}
			</span>
		</Button>
	);
}
